import React, { useEffect, useState } from "react";
import { API_URL } from "./config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Sermons = () => {
    const navigate = useNavigate();
    const [sermons, setSermons] = useState([]); // Start with empty array
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorLoading, setErrorLoading] = useState(false);

    useEffect(() => {
        const fetchSermons = async () => {
            try {
                const response = await fetch(`${API_URL}/sermons`, {
                    headers: { "Content-Type": "application/json" }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setSermons(data);
            } catch (error) {
                console.error('Error fetching sermons:', error);
                setErrorLoading(true);

            } finally {
                setLoading(false);
            }
        };

        fetchSermons();
    }, []);

    const filteredSermons = sermons.filter(sermon =>
        sermon.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div style={styles.container}>

             <div style={styles.headerContainer}>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    <ArrowBackIcon style={styles.backIcon} />
                </button>
                <h4 style={styles.heading}>Sermons</h4>
            </div>


            <div style={styles.searchContainer}>
                <input
                    type="text"
                    placeholder="Search sermons..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={styles.searchInput}
                />
            </div>

            {loading ? (
                <p style={styles.loadingText}>Loading sermons...</p>
            ) : errorLoading ? (
                <p >Connection error, check your network connection</p>
            ) : filteredSermons.length === 0 ? (
                <p style={styles.noResults}>No sermons found{searchQuery && ` for "${searchQuery}"`}</p>
            ) : (
                <div style={styles.listContainer}>
                    {filteredSermons.map((sermon) => (
                        <div key={sermon.id} style={styles.sermonCard}>
                            <h5 style={styles.sermonTitle}>{sermon.name}</h5>
                            <p style={styles.sermonDate}>Date: {new Date(sermon.date).toLocaleDateString()}</p>
                            <a
                                href={sermon.weblink}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={styles.youtubeLink}
                            >
                                Watch on YouTube
                            </a>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
const styles = {
  container: {
    padding: "20px",
    maxWidth: "500px",
    margin: "0 auto",
    marginBottom: "60px",
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '800px',
    marginBottom: '15px',
    position: 'relative'
  },
  backButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    marginRight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    ':hover': {
      backgroundColor: '#f0f2f5'
    }
  },
    backIcon: {
        color: '#1a6363',
        fontSize: '28px'
    },
    heading: {
        flex: 1,
        textAlign: 'center',
        fontSize: '24px',
        color: '#1a6363',
        fontWeight: '600',
        margin: 0,
        paddingRight: '52px'
    },
    searchContainer: {
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '0 auto 20px auto',
        padding: '0 15px',
        maxWidth: '800px',
        justifyContent: 'center'
    },
    searchInput: {
        width: '100%',
        maxWidth: '500px',
        padding: '12px 15px',
        borderRadius: '8px',
        border: '1px solid #1a6363',
        fontSize: '16px',
        outline: 'none',
        transition: 'border-color 0.3s ease',
    },
    listContainer: {
        margin: '0 auto',
        width: '100%',
        maxWidth: '800px'
    },
    sermonCard: {
        border: '1px solid #1a6363',
        borderRadius: '10px',
        padding: '20px',
        margin: '15px 0',
        backgroundColor: '#f8fafb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s ease'
    },
    sermonTitle: {
        margin: '0',
        fontSize: '18px',
        color: '#1a6363',
        fontWeight: '600'
    },
    sermonDate: {
        margin: '8px 0',
        fontSize: '14px',
        color: '#666'
    },
    youtubeLink: {
        display: 'inline-block',
        backgroundColor: '#1a6363',
        color: '#fff',
        textDecoration: 'none',
        padding: '10px 20px',
        borderRadius: '6px',
        fontSize: '14px',
        marginTop: '12px',
        transition: 'background-color 0.3s ease',
        cursor: 'pointer'
    },
    loadingText: {
        fontSize: '16px',
        color: '#666',
        textAlign: 'center'
    },
    errorText: {
        fontSize: '16px',
        color: '#d32f2f',
        textAlign: 'center'
    },
    noResults: {
        fontSize: '16px',
        color: '#666',
        textAlign: 'center',
        marginTop: '20px'
    }
};

export default Sermons;
